/**
 * @module utils/auth
 */

export function hasAccess (levels, level) {
  if (levels.indexOf(level) !== -1) {
    return true
  } else {
    return false
  }
}

/**
 * ``` ```
 * @deprecated, Use `hasSubscriptionPermission` instead, it uses the newer subscription modules
 */
export function hasPermission (authObject, ids, availableFree, availablePro) {
  console.log('USING WRONG PERMISSION FUNCTION!!!, CHANGE IT!!')
  // Object.keys(authObject.permissions.EmployeePermissions).length === 0 ||
  if (!authObject || authObject.permissions || authObject.permissions.EmployeePermissions === undefined || typeof authObject.permissions.EmployeePermissions === 'undefined') return false
  if (authObject.permissions.ShopSubscriptionType === 1) {
    if (!availableFree) return false
  } else {
    if (availablePro !== undefined) {
      if (!availablePro) return false
    }
  }
  // console.log('Check permission for id: ', id)

  // Check permission array
  let permissionIds = authObject.permissions.EmployeePermissions.map(function (v) {
    return v.Id
  })

  if (ids.constructor === Array) {
    // settings only
    // if ids is an array, it needs one true
    let hasOnePermission = false
    for (let i = 0; i < ids.length; i++) {
      if (ids[i].constructor === Array) {
        // if ids[i] is an array, it all needs to be true
        let allPermissions = true
        for (let j = 0; j < ids[i].length; j++) {
          if (permissionIds.indexOf(ids[i][j]) === -1) {
            allPermissions = false
          }
        }
        if (allPermissions) {
          hasOnePermission = true
        }
      } else {
        // if ids[i] is an int
        if (permissionIds.indexOf(ids[i]) !== -1) hasOnePermission = true
      }
    }
    return hasOnePermission
  } else {
    // if ids is an int (everything else than settings)
    if (ids !== 0 && permissionIds.indexOf(ids) === -1) return false
  }

  return true
}

export function hasPartnerSubscriptionPermission (authObject, subscriptionValue) {
  if (subscriptionValue === undefined || subscriptionValue === null) subscriptionValue = -10 // None as default
  if (!authObject || !authObject.permissions) return false
  if (authObject.permissions.PartnerSubscriptionValue < subscriptionValue) {
    return false
  }

  return true
}

export function hasSubscriptionPermission (authObject, subscriptionValue, ids) {
  if (!authObject || !authObject.permissions || authObject.permissions.EmployeePermissions === undefined || typeof authObject.permissions.EmployeePermissions === 'undefined') return false
  if (subscriptionValue === undefined || subscriptionValue === null) subscriptionValue = -10 // None as default
  if (authObject.permissions.ShopSubscriptionValue < subscriptionValue) {
    return false
  }

  if (ids === undefined || ids === null || ids.length === 0) {
    return true
  }

  // Check permission array
  let permissionIds = authObject.permissions.EmployeePermissions.map(function (v) {
    return v.Id
  })

  if (ids.constructor === Array) {
    // settings only
    // if ids is an array, it needs one true
    let hasOnePermission = false
    for (let i = 0; i < ids.length; i++) {
      if (ids[i].constructor === Array) {
        // if ids[i] is an array, it all needs to be true
        let allPermissions = true
        for (let j = 0; j < ids[i].length; j++) {
          if (permissionIds.indexOf(ids[i][j]) === -1) {
            allPermissions = false
          }
        }
        if (allPermissions) {
          hasOnePermission = true
        }
      } else {
        // if ids[i] is an int
        if (permissionIds.indexOf(ids[i]) !== -1) hasOnePermission = true
      }
    }
    return hasOnePermission
  } else {
    // if ids is an int (everything else than settings)
    if (ids !== 0 && permissionIds.indexOf(ids) === -1) return false
  }

  return true
}

/**
 * Determines whether a user is within one of the chains allowed to use order assigning.
 * @param authObject The authObject who´s user to check for.
 * @example hasAccessToAssign(this.props.auth)
 */
export function hasAccessToAssign (authObject) {
  // Only allowed for QARS and AkzoNobel Norge chains - 2021-11-08
  // return (authObject !== undefined && authObject !== null && authObject.user !== undefined && authObject.user !== null && [2, 7].includes(parseInt(authObject.user.ChainId)))
  return true
}

export function isTopOfStackChain (inactiveUsers) {
  if (inactiveUsers.length !== 0) {
    if (inactiveUsers[0].UserType === 2) return true
  }
  return false
}

export function isLoginFromShopOwner (inactiveUsers) {
  let found = false
  inactiveUsers.map((val) => {
    if (val.UserType === 7 || val.UserType === 8) found = true
  })
  return found
}

export function isLoginFromShop (inactiveUsers) {
  let found = false
  inactiveUsers.map((val) => {
    if (val.UserType === 5) found = true
  })
  return found
}

export function isLoginFromChainOrSuper (inactiveUsers) {
  let found = false
  inactiveUsers.map((val) => {
    if (val.UserType === 1 || val.UserType === 2) found = true
  })
  return found
}

export function isLoginFromWP (inactiveUsers) {
  let found = false
  inactiveUsers.map(val => {
    if (val.UserType === 6) found = true
  })
  return found
}

export function hasDepartmentType (authObject, validDepartmentTypes, UserType, shopsToCheck) {
  // if it isn't a userType that needs a specifik department, return true
  if (shopsToCheck.indexOf(UserType) === -1) return true

  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined' || validDepartmentTypes === undefined) return false
  if (validDepartmentTypes.indexOf(authObject.departmentType) !== -1) {
    return true
  } else {
    return false
  }
}

export function hasPaintShop (authObject) {
  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined') return false
  if (authObject.departmentType === 0 || authObject.departmentType === 2) { // PaintShop and Both
    return true
  }
  return false
}

export function hasBodyShop (authObject) {
  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined') return false
  if (authObject.departmentType === 1 || authObject.departmentType === 2) { // BodyShop and Both
    return true
  }
  return false
}

export function hasCombinedBodyPaintShop (authObject) {
  if (authObject.departmentType === undefined || typeof authObject.departmentType === 'undefined') return false
  if (authObject.departmentType === 2) { // PaintShop and BodyShop
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/app/utils/auth.js